<mat-dialog-content class="mat-typography p-0 bg-white shadow-2xl rounded-lg w-full h-full">
  <mat-card class="overflow-auto w-full h-full flex flex-col">
    <mat-card-header class="bg-orange-500 text-white py-4 px-6">
      <mat-card-title class="text-2xl font-bold">Detalle del Proceso de Facturación - ID: {{ billingProcess.id
        }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="text-gray-800 p-0 flex-grow overflow-y-auto">
      <div class="p-6">
        <table class="w-full divide-y divide-gray-300 h-full">
          <tbody class="text-base">
            <tr class="border-b border-gray-200">
              <td class="font-bold py-3 px-4">Status:</td>
              <td class="text-blue-600 py-3 px-4">{{ billingProcess.status }}</td>
            </tr>
            <tr class="border-b border-gray-200">
              <td class="font-bold py-3 px-4">Proveedores Totales:</td>
              <td class="text-blue-600 py-3 px-4">{{ billingProcess.totalProviders }}</td>
            </tr>
            <tr class="border-b border-gray-200">
              <td class="font-bold py-3 px-4">Proveedores Fallidos:</td>
              <td class="text-red-600 py-3 px-4">{{ billingProcess.failedProvidersAmount }}</td>
            </tr>
            <tr class="border-b border-gray-200">
              <td class="font-bold py-3 px-4">Proveedores Enviados:</td>
              <td class="text-green-500 py-3 px-4">{{ billingProcess.sentProvidersAmount }}</td>
            </tr>
            <tr class="border-b border-gray-200">
              <td class="font-bold py-3 px-4">Fecha de Registro:</td>
              <td class="text-gray-700 py-3 px-4">{{ billingProcess.date }}</td>
            </tr>
            <tr class="border-b border-gray-200">
              <td class="font-bold py-3 px-4">Fecha de Inicio:</td>
              <td class="text-gray-700 py-3 px-4">{{ billingProcess.billingStartDate }}</td>
            </tr>
            <tr class="border-b border-gray-200">
              <td class="font-bold py-3 px-4">Fecha de Fin:</td>
              <td class="text-gray-700 py-3 px-4">{{ billingProcess.billingEndDate }}</td>
            </tr>
            <tr class="border-b border-gray-200">
              <td class="font-bold py-3 px-4">Proveedores:</td>
              <td class="py-3 px-4">
                <ul class="list-disc pl-6">
                  <li *ngFor="let provider of billingProcess.providers" class="text-gray-600">
                    {{ provider.name }} (ID: {{ provider.id }})
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td class="font-bold py-3 px-4">Filtros Aplicados:</td>
              <td class="py-3 px-4 text-gray-600">{{ billingProcess.filters.join(', ') }}</td>
            </tr>
            <tr *ngIf="activityLog && activityLog.length > 0" class="border-b border-gray-200">
              <td class="font-bold py-3 px-4">Registro de Eventos:</td>
              <td>
                <ul *ngFor="let event of activityLog">
                  <li [innerHTML]="event.descriptionAsArray | descriptionArrayPipe"></li>
                </ul>
              </td>
            </tr>
            <tr *ngIf="!activityLog || activityLog.length === 0" class="border-b border-gray-200">
              <td colspan="2" class="py-3 px-4 text-gray-600">No hay registros de actividad para este proceso.</td>
            </tr>

          </tbody>
        </table>
      </div>
    </mat-card-content>
    <mat-card-actions class="flex justify-end py-4 px-6 bg-gray-100">
      <button mat-button mat-dialog-close class="text-blue-700 hover:text-blue-900 text-lg">Cerrar</button>
    </mat-card-actions>
  </mat-card>
</mat-dialog-content>